// extracted by mini-css-extract-plugin
export default {"tags":"tags_q74f","tag":"tag_lSC7"};